<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <divisoria-descricao
            :titulo="'Dados de Envio'"
            :descricao="'Preencha os dados iniciais para envio e vincule o gerente responsável pela proposta.'"
          />
        </b-col>
      </b-row>

      <!-- 1. EMPRESA PRIMEIRO -->
      <empresa-contrante
        ref="empresaContratante"
        :value="proposta.empresasPessoa"
        :tipo-proposta="proposta.tipoProposta"
        :mostrar-botao="proposta.id && (proposta.statusProposta !== 'pendenteenvio' && proposta.statusProposta !== 'naoaprovada') && (!proposta.empresasPessoa || proposta.empresasPessoa.length === 0)"
        :status-proposta="proposta.statusProposta"
        :proposta-id="proposta.id"
        :proposta="proposta"
        :pessoa="proposta.pessoa"
        @select="empresaSelecionada"
        @salvo-contratante="selecionadoEmpresas($event, true)"
        @remover-empresa="proposta.empresasPessoa = []"
        @pessoa-criada="pessoaCriadaDeEmpresa"
      />

      <!-- 2. PESSOA DEPOIS -->
      <b-row>
        <b-col :cols="'6'">
          <div style="display: flex;">
            <div style="flex: 1;">
              <legend style="font-size: 14px;">
                Pessoa
              </legend>
              <pessoa-select
                ref="pessoaMultiselect"
                v-model="proposta.pessoa"
                :require="true"
                :multiple="false"
                :label="''"
                :disabled="desabilitarSelecaoPessoa"
                @input="pessoaSelecionada"
              />
            </div>

            <!-- Botão para criar nova pessoa -->
            <b-btn
              v-b-tooltip.hover.top
              title="Criar nova pessoa"
              size="sm"
              variant="none"
              class="btn-actions"
              style="width: 35px; margin-left: 0.5rem; margin-top: 1.2rem;"
              @click="abrirModalCriarPessoaManual"
            >
              <font-awesome-icon
                :icon="faPlus"
                :class="'text-primary'"
                style="width:18px"
              />
            </b-btn>

            <!-- Botão para abrir cadastro em nova aba -->
            <b-btn
              v-b-tooltip.hover.top
              title="Abrir cadastro em nova aba"
              size="sm"
              variant="none"
              class="btn-actions"
              style="width: 35px;margin-left: -0.5rem;margin-top: 1.2rem;"
              @click="abrirCadastroPessoa"
            >
              <font-awesome-icon
                :icon="faExternalLinkAlt"
                :class="'text-primary'"
                style="width:22px"
              />
            </b-btn>
          </div>
        </b-col>
        <b-col cols="6">
          <telefone-celular
            :value="telefoneContato"
            :disabled="true"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-form-group
          label="E-mail"
          class="col-6"
        >
          <b-form-input
            v-model="emailPessoa"
            :disabled="true"
          />
        </b-form-group>
        <b-col cols="6">
          <div class="div-email">
            <div>
              <legend style="font-size: 14px">
                E-mails em Cópia (CC)</legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover.html
                title="E-mails que receberão a cópia do e-mail de notificação referente ao envio da Proposta Comercial com link de acesso ao Portal.
                <strong><br>Atenção: qualquer registro realizado pelo e-mail CC no portal externo ficará registrado com os dados da pessoa principal vinculada a proposta.</strong>"
                style="font-size: 0.65rem"
                class="question-icon"
              >
                <font-awesome-icon :icon="faQuestionCircle" />
              </i>
            </div>
          </div>
          <b-form-tags
            v-model="proposta.emailsCC"
            input-id="tags-emails"
            placeholder=""
            separator=" "
            invalid-tag-text=""
            duplicate-tag-text=""
            :tag-validator="validator"
            :add-button-text="'Adicionar'"
            remove-on-delete
            tag-class="tags"
            :disabled="proposta.id && (proposta.statusProposta !== 'pendenteenvio' && proposta.statusProposta !== 'naoaprovada')"
            @tag-state="onTagState"
          />
          <small
            v-if="invalidTags.length > 0"
            class="text-danger"
          >Insira um email válido</small>
          <small
            v-else-if="duplicateTags.length > 0"
            class="text-danger"
          >E-mail já inserido nesse campo
          </small>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <responsavel-select
            ref="filtroGerente"
            v-model="proposta.gerente"
            :label="'Responsável'"
            :require-usuario="true"
            :disabled="true"
            @input="gerenteSelecionado"
          />

        </b-col>
        <b-form-group
          label="E-mail do Responsável"
          class="col-6"
        >
          <b-form-input
            v-model="emailGerente"
            :disabled="true"
          />
        </b-form-group>
      </b-row>

      <b-row
        v-if="proposta.tipoProposta && proposta.tipoProposta !== 'semchecklist'"
        class="mt-1"
        align-v="center"
      >
        <b-col cols="12">
          <legend style="font-size: 14px">
            Contratante(s)</legend>
          <b-form-tags
            id="tags-empresa"
            v-model="proposta.empresasPessoa"
            :placeholder="proposta.empresasPessoa && proposta.empresasPessoa.length > 0 ? '' : 'O sistema vinculará automaticamente o contratante ao realizar o cadastro de empresa!'"
            :disabled="true"
            separator=" "
          >
            <template v-slot="{ tags }">
              <b-badge
                v-for="tag in tags"
                :key="tag"
                v-b-tooltip.hover.top
                title="Abrir cadastro em nova aba"
                variant="success"
                class="mr-50"
                style="cursor: pointer;"
                @click="abrirCadastroEmpresa(JSON.parse(tag).id)"
              >
                <span style="font-size: 11px;font-weight: 500;">{{ JSON.parse(tag).cadastroFederal + ' - ' +
                  JSON.parse(tag).razaoSocial }}</span>
              </b-badge>
            </template>
          </b-form-tags>
        </b-col>
      </b-row>

      <!--Checklist-->
      <b-row
        v-if="proposta.tipoProposta === 'constituicao' || proposta.tipoProposta === 'transferencia'"
        class="mt-2"
      >
        <b-col>
          <checklist
            ref="checklist"
            v-model="proposta"
            :gerado-proposta="proposta.geradoProposta"
            @habilitar-botao="habilitarBotao"
          />
        </b-col>
      </b-row>

      <!--Serviços e Pacote-->
      <div v-if="mostraGrupoItens">
        <b-row class="mt-2">
          <b-col>
            <divisoria-descricao
              :titulo="'Itens da Proposta'"
              :descricao="'Preencha os dados personalizados e selecione os serviços desta proposta.'"
            />
          </b-col>
        </b-row>

        <div
          :class="[
            {
              'desabilitar-inputs': proposta.id
                && (proposta.statusProposta !== 'pendenteenvio'
                  && proposta.statusProposta !== 'naoaprovada'
                  && (!proposta.etiquetas.some(som => som.descricao === 'Em Alteração')
                    || permissaoAlterarPropostaAprovada === false))
            }
          ]"
        >
          <b-row>
            <b-form-group
              label="Template de Proposta"
              class="col-9"
            >
              <validation-provider
                #default="{ errors }"
                name="Template de Proposta"
                :rules="'required'"
              >
                <b-form-select
                  v-model="proposta.templatePropostaId"
                  :options="templatesProposta"
                  :disabled="false"
                />
                <small
                  v-if="errors[0]"
                  class="text-danger"
                >O campo Template de Proposta é obrigatório</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Gera Contrato"
              class="col-3"
            >
              <b-form-select
                v-model="proposta.geraContrato"
                :options="[
                  { value: true, text: 'Sim' },
                  { value: false, text: 'Não' },
                ]"
                :disabled="desabilitarGeraContrato"
                @input="alteraTemplateContrato"
              />
            </b-form-group>
          </b-row>

          <b-row class="mt-1">
            <b-col>
              <div style="display: flex; justify-content: flex-end">
                <div class="mr-50">
                  <legend class="col-form-label pt-0">
                    Tipo do Acréscimo/Desconto:
                  </legend>
                </div>
                <div>
                  <b-form-radio-group
                    v-model="tipoAcresDesc"
                    :options="[{ text: 'R$', value: 'R$' }, { text: '%', value: '%', disabled: true }]"
                    @change="mudarPorcentagem"
                  />
                </div>
              </div>
            </b-col>
          </b-row>

          <tabela-pacote-servico
            v-model="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            :tabela-index="0"
            @subtotal-pacote="somaValorTotalProposta"
            @subtotal-remove="retiraValorTotalProposta"
            @update-os-constituicao="updateOsConstituicao($event)"
          />

          <tabela-pacote-servico
            v-if="mostrarOutrosPacotes"
            v-model="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            :tabela-index="1"
            @subtotal-pacote="somaValorTotalProposta"
            @subtotal-remove="retiraValorTotalProposta"
          />

          <tabela-pacote-servico
            v-if="mostrarOutrosPacotes"
            v-model="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            :tabela-index="2"
            @subtotal-pacote="somaValorTotalProposta"
            @subtotal-remove="retiraValorTotalProposta"
          />

          <tabela-servico-proposta
            v-if="mostrarTabelaServicos"
            v-model="proposta.servicos"
            :proposta="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            @subtotal-servicos="somaValorTotalProposta"
            @update-os-constituicao="updateOsConstituicao($event)"
          />

          <tabela-servico-adicional
            ref="tabelaServicoAdicional"
            v-model="proposta.servicosAdicionais"
            :proposta="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            @subtotal-servicos-adicionais="somaValorTotalProposta"
            @update-os-constituicao="updateOsConstituicao($event)"
          />
        </div>

        <b-row>
          <b-col
            style="
            display: flex;
            justify-content: flex-end;
            word-break: break-all;
          "
          >
            <b-table
              :items="[proposta.valorTotalPropostaRCC]"
              :fields="[
                {
                  key: 'valorTotal',
                  label: 'Valor total',
                  thStyle: 'font-size: 14.5px;',
                },
              ]"
              bordered
              class="tabela-total"
            >
              <template #head(valorTotal)>
                <div>
                  <i
                    v-if="proposta.propostasPacotes.length > 1"
                    v-b-tooltip.hover.html
                    title="Quando a proposta tem escolha de pacote e ação de escolha estiver pendente com a pessoa, o sistema considerará no valor total da proposta somente o pacote nível I."
                    style="font-size: 0.65rem; display: inline-flex;padding: 3px;"
                    class="question-icon"
                  >
                    <font-awesome-icon :icon="faQuestionCircle" />
                  </i>
                  <span>Valor total: {{ proposta.valorTotalPropostaAuditar ?
                    proposta.valorTotalPropostaAuditar.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) :
                    0.0 | converteValor }}</span>
                </div>
              </template>
              <template #cell(valorTotal)="{ item }">
                <span style="font-size: 12.8px">RCC: {{ item ? item.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }) : 0.0 | converteValor }}</span>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>
    </b-col>

    <!-- Modal: Criar Pessoa Manual -->
    <modal-criar-pessoa
      ref="modalCriarPessoaManual"
      :empresa-id="proposta.empresasPessoa && proposta.empresasPessoa.length > 0 ? proposta.empresasPessoa[0].id : null"
      @pessoa-criada="pessoaCriadaManualmente"
    />
  </b-row>
</template>

<style lang="scss">
.desabilitar-inputs {
  pointer-events: none;
}

.alinhar-campo-pessoa {
  display: flex;
  align-items: baseline;
}

#tags-empresa ::placeholder {
  font-style: italic;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ValidationProvider } from 'vee-validate'
import {
  faQuestionCircle, faExternalLinkAlt, faPlus,
} from '@fortawesome/free-solid-svg-icons'
import { getUserData, isAdmin, permitidoAcessarRecurso } from '@/auth/utils'
import { abrirEmNovaGuia } from '@/@core/utils/utils'
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplateProposta/services/api'
import pessoaApi from '@/app-modulo/comercial/pessoa/shared/services/api'
import ModalCriarPessoa from '../modal-criar-pessoa/ModalCriarPessoa.vue'

export default {
  name: 'DadosEnvio',
  components: {
    FontAwesomeIcon,
    ValidationProvider,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    PessoaSelect: () => import('@/shared/components/pessoa-select/PessoaSelect.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    ResponsavelSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
    TabelaServicoProposta: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/tabela-servico/TabelaServicoProposta.vue'),
    TabelaServicoAdicional: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/tabela-servico-adicional/TabelaServicoAdicional.vue'),
    TabelaPacoteServico: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/tabela-pacote-servico/TabelaPacoteServico.vue'),
    Checklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/ChecklistProposta.vue'),
    EmpresaContrante: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/empresa-contratante/EmpresaContratante.vue'),
    ModalCriarPessoa,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    tipoProposta: {
      type: String,
      default: 'semchecklist',
    },
    empresaInicial: {
      type: Object,
      default: null,
    },
    pessoaInicial: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      faQuestionCircle,
      faExternalLinkAlt,
      faPlus,
      proposta: this.value,
      invalidTags: [],
      duplicateTags: [],
      desabilitarTemplate: true,
      telefoneContato: {},
      emailPessoa: null,
      emailGerente: null,
      tipoAcresDesc: '',
      totalAuditarServico: 0,
      totalRCCServico: 0,
      totalAuditarServicoAdicional: 0,
      totalRCCServicoAdicional: 0,
      totalAuditarPacote: 0,
      totalRCCPacote: 0,
      desabilitarGeraContrato: false,
      permissaoAlterarPropostaAprovada: getUserData().permissaoAlterarPropostaAprovada,
      templatesProposta: [],
    }
  },
  computed: {
    ...mapGetters('proposta', ['getCheckOsConstituicao', 'getStatusProposta']),
    mostraGrupoItens() {
      return this.proposta.tipoProposta === 'semchecklist'
        || ((this.proposta.tipoProposta === 'constituicao' || this.proposta.tipoProposta === 'transferencia') && this.proposta.geradoProposta)
    },
    mostrarOutrosPacotes() {
      return (this.proposta.tipoProposta === 'constituicao' || this.proposta.tipoProposta === 'transferencia') && !this.proposta.filial && this.proposta?.propostasPacotes?.length > 1
    },
    desabilitarSelecaoPessoa() {
      return (this.proposta.id && (this.proposta.statusProposta !== 'pendenteenvio' && this.proposta.statusProposta !== 'naoaprovada'))
        || ((this.proposta.statusProposta === 'pendenteenvio' || this.proposta.statusProposta === 'naoAprovada') && this.proposta.copia && this.proposta.tipoProposta !== 'semchecklist')
    },
    mostrarTabelaServicos() {
      return (this.proposta.tipoProposta === 'semchecklist') || (this.proposta.tipoProposta !== 'semchecklist' && this.proposta.servicos.some(som => som.servico))
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.proposta = value
        this.desabilitarGeraContrato = this.tipoProposta === 'semchecklist'
        this.adicionarDados(this.proposta)
      }
    },
    empresaInicial: {
      immediate: true,
      handler(value) {
        this.$nextTick(() => {
          this.aplicarEmpresaInicial(value)
        })
      },
    },
    pessoaInicial: {
      immediate: true,
      handler(value) {
        this.$nextTick(() => {
          this.aplicarPessoaInicial(value)
        })
      },
    },
  },
  created() {
    this.proposta = this.value
    this.desabilitarGeraContrato = this.tipoProposta === 'semchecklist'
    this.getPropostaTemplates(this.tipoProposta)
    // --- NOVO BLOCO: definir responsável automático ---
    if (!this.proposta.id && !this.proposta.gerente) {
    // opção 1: se o userData já tiver tudo
      const usuarioLogado = getUserData()

      if (usuarioLogado && usuarioLogado.id) {
        this.proposta.gerente = {
          id: usuarioLogado.id,
          nomeCompleto: usuarioLogado.nomeCompleto,
          email: usuarioLogado.email,
        }
        this.emailGerente = usuarioLogado.email
      }
    }

    if (this.proposta) {
      this.adicionarDados(this.proposta)
    } else {
      this.tipoAcresDesc = 'R$'
    }
  },
  methods: {
    ...mapActions('proposta', ['setCheckOsConstituicao']),
    async aplicarEmpresaInicial(empresa) {
      // Não aplicar empresa inicial para propostas de constituição
      if (this.tipoProposta === 'constituicao' || (this.proposta && this.proposta.tipoProposta === 'constituicao')) {
        return
      }

      if (!empresa || !empresa.id || !this.proposta || this.proposta.id) {
        return
      }

      const atual = Array.isArray(this.proposta.empresasPessoa)
        && this.proposta.empresasPessoa.length > 0
        ? this.proposta.empresasPessoa[0]
        : null

      if (atual && atual.id === empresa.id) {
        return
      }

      const empresaFormatada = {
        id: empresa.id,
        razaoSocial: empresa.razaoSocial || empresa.nome || '',
        cadastroFederal: empresa.cadastroFederal || empresa.cnpj || '',
        pessoaPreferidaId: empresa.pessoaPreferidaId || null,
      }

      this.proposta.empresasPessoa = [empresaFormatada]
      this.empresaSelecionada(empresaFormatada)

      if (empresaFormatada.id) {
        await this.carregarPessoasDaEmpresa(
          empresaFormatada.id,
          empresaFormatada.pessoaPreferidaId
            || (this.pessoaInicial ? this.pessoaInicial.id : null),
        )
      }
    },
    async aplicarPessoaInicial(pessoa) {
      if (!pessoa || !pessoa.id || !this.proposta || this.proposta.id) {
        return
      }

      if (this.proposta.pessoa && this.proposta.pessoa.id === pessoa.id) {
        return
      }

      const detalhes = await this.obterPessoaDetalhes(pessoa.id, pessoa)
      this.proposta.pessoa = detalhes
      this.pessoaSelecionada(detalhes)
    },
    async obterPessoaDetalhes(id, fallback = {}) {
      try {
        const response = await pessoaApi.getPessoa(id)
        return response.data
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Erro ao carregar pessoa inicial:', error)
        return {
          id,
          nome: fallback.nome || fallback.personName || '',
          email: fallback.email || '',
          telefone: fallback.telefone || '',
          telefoneWhatsApp: fallback.telefoneWhatsApp || false,
          celular: fallback.celular || '',
          celularWhatsApp: fallback.celularWhatsApp || false,
        }
      }
    },
    selecionadoEmpresas(value, salvo) {
      if (!salvo && (!this.proposta.id || this.proposta.statusProposta === 'pendenteenvio' || this.proposta.statusProposta === 'naoaprovada')) {
        this.proposta.empresasPessoa = []
        this.proposta.empresasPessoa.push(value)
      } else if (salvo) {
        this.proposta.empresasPessoa.push(value)
      }
    },
    abrirCadastroPessoa() {
      if (isAdmin()) {
        if (this.proposta.pessoa && this.proposta.pessoa.id > 0) {
          abrirEmNovaGuia('editar-pessoa', this.proposta.pessoa.id)
        } else {
          abrirEmNovaGuia('pessoas')
        }
      } else {
        const ability = permitidoAcessarRecurso('pessoa')
        if (ability) {
          if (this.proposta.pessoa && this.proposta.pessoa.id > 0 && ability.actions.some(som => som === 'update')) {
            abrirEmNovaGuia('editar-pessoa', this.proposta.pessoa.id)
          } else {
            abrirEmNovaGuia('pessoas')
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
    abrirCadastroEmpresa(value) {
      if (isAdmin()) {
        abrirEmNovaGuia('editar-emp', value)
      } else {
        const ability = permitidoAcessarRecurso('empresa')
        if (ability) {
          if (ability.actions.some(som => som === 'update')) {
            abrirEmNovaGuia('editar-emp', value)
          } else {
            abrirEmNovaGuia('empresas')
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
    adicionarDados(dados) {
      this.telefoneContato = dados.pessoa ? dados.pessoa.telefoneContato : {}
      this.emailPessoa = dados.pessoa ? dados.pessoa.email : null
      this.emailGerente = dados.gerente ? dados.gerente.email : null
      this.tipoAcresDesc = dados.porcentagem ? '%' : 'R$'
    },
    pessoaSelecionada(value) {
      if (value) {
        this.telefoneContato = {
          telefone: value.telefone,
          telefoneWhatsApp: value.telefoneWhatsApp,
          celular: value.celular,
          celularWhatsApp: value.celularWhatsApp,
        }
        this.emailPessoa = value.email
      }
      // Não limpar empresasPessoa - no novo fluxo, empresa é selecionada primeiro
      // this.proposta.empresasPessoa = []
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    gerenteSelecionado(value) {
      if (value) {
        this.emailGerente = value.email
      }
    },
    alteraTemplateContrato(value) {
      if (!value) {
        this.proposta.templateContrato = null
      } else {
        this.proposta.templateContrato = 'Contrato padrão'
      }
    },
    somaValorTotalProposta(array) {
      if (array.tipo === 'servico') {
        this.totalAuditarServico = array.subTotal
        this.totalRCCServico = array.subTotalRCC
      }

      if (array.tipo === 'servicoAdicional') {
        this.totalAuditarServicoAdicional = array.subTotal
        this.totalRCCServicoAdicional = array.subTotalRCC
      }

      if (array.tipo === 'pacote') {
        this.totalAuditarPacote = array.subTotal
        this.totalRCCPacote = array.subTotalRCC
      }

      this.proposta.valorTotalPropostaAuditar = this.totalAuditarServico + this.totalAuditarServicoAdicional + this.totalAuditarPacote
      this.proposta.valorTotalPropostaRCC = this.totalRCCServico + this.totalRCCServicoAdicional + this.totalRCCPacote
    },
    retiraValorTotalProposta(array) {
      this.totalAuditarPacote = array.subTotal
      this.totalRCCPacote = array.subTotalRCC

      this.proposta.valorTotalPropostaAuditar -= this.totalAuditarPacote
      this.proposta.valorTotalPropostaRCC -= this.totalRCCPacote
    },
    limparDadosEnvio() {
      this.telefoneContato = {}
      this.emailPessoa = null
      this.emailGerente = null
    },
    mudarPorcentagem(value) {
      if (value === '%') {
        this.proposta.porcentagem = true
      } else {
        this.proposta.porcentagem = false
      }
    },
    habilitarBotao(value) {
      this.$emit('habilitar-botao', value)
    },
    setEmpresaContratanteObrigatorio() {
      this.$refs.empresaContratante.obrigatorio = true
    },
    updateOsConstituicao(pacoteSelecionado) {
      if (this.proposta.statusProposta !== 'finalizada') {
        let pacoteServico = false
        if (pacoteSelecionado && pacoteSelecionado.servicos.length > 0) {
          pacoteServico = pacoteSelecionado.servicos.some(s => s.osConstituicao)
        } else {
          pacoteServico = this.proposta.propostasPacotes[0].servicos?.some(a => a.osConstituicao)
        }
        const servico = this.proposta.servicos?.some(s => s.servico?.osConstituicao)
        const servicoAdicional = this.proposta.servicosAdicionais?.some(s => s.servico?.osConstituicao)
        if (pacoteServico || servico || servicoAdicional) {
          this.setCheckOsConstituicao(true)
          this.proposta.empresasPessoa = []
          if (this.proposta.semContratante) {
            this.proposta.semContratante = false
          }
        } else {
          this.setCheckOsConstituicao(false)
        }
      }
    },
    getPropostaTemplates(tipoProposta = null) {
      api.getTemplatesResumidos(tipoProposta).then(payload => {
        this.templatesProposta = payload.data.map(item => ({
          value: item.id,
          text: item.descricao,
        }))
      })
    },

    empresaSelecionada(empresa) {
      // Empresa selecionada pelo componente EmpresaContratante (inclui fluxo de busca por CNPJ)
      // Sempre considera a empresa selecionada como contratante principal da proposta
      if (empresa) {
        this.proposta.empresasPessoa = [empresa]
      } else {
        this.proposta.empresasPessoa = []
      }
    },

    async carregarPessoasDaEmpresa(empresaId, pessoaIdPreferida = null) {
      try {
        const empresaApi = await import('@/app-modulo/comuns/empresa/shared/services/api')
        const response = await empresaApi.default.getPessoasEmpresa(empresaId)
        if (response.data && response.data.length > 0) {
          let pessoa = response.data[0]

          // Se foi informada uma pessoa especA�fica, tenta selecionA!-la
          if (pessoaIdPreferida) {
            const encontrada = response.data.find(p => p.id === pessoaIdPreferida)
            if (encontrada) {
              pessoa = encontrada
            }
          }

          // Auto-seleciona a pessoa vinculada
          this.proposta.pessoa = pessoa
          this.pessoaSelecionada(pessoa)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Erro ao carregar pessoas da empresa:', error)
      }
    },

    async pessoaCriadaDeEmpresa(pessoaData) {
      // Callback quando pessoa Ac criada a partir da empresa (fluxo CNPJ)

      // Recarrega as opA�Aues do select de pessoa para incluir o novo registro
      if (this.$refs.pessoaMultiselect && this.$refs.pessoaMultiselect.recarregarItens) {
        await this.$refs.pessoaMultiselect.recarregarItens()
      }

      // Seleciona diretamente a pessoa recA�m-criada
      this.proposta.pessoa = pessoaData
      this.pessoaSelecionada(pessoaData)
    },

    abrirModalCriarPessoaManual() {
      this.$refs.modalCriarPessoaManual.show()
    },

    async pessoaCriadaManualmente(pessoaData) {
      // Callback quando pessoa Ac criada manualmente via botA���o +

      // Recarrega as opA�Aues do select de pessoa
      if (this.$refs.pessoaMultiselect && this.$refs.pessoaMultiselect.recarregarItens) {
        await this.$refs.pessoaMultiselect.recarregarItens()
      }

      // Seleciona diretamente a pessoa recA�m-criada
      this.proposta.pessoa = pessoaData
      this.pessoaSelecionada(pessoaData)
    },
  },
}
</script>
